// This store represents the App status
import { writable } from 'svelte/store';
import { GameStatus } from '../enums';
export const appStatus = writable(GameStatus.UNSTARTED);
export const displayMapStore = writable(false);
export const playMusicStore = writable(true);
export const playSoundsStore = writable(true);
